import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from './landing/LandingPage';
import { resolveTenantContext } from './utils/subdomain';

/**
 * RootRoute checks the current hostname.
 * If it matches one of the defined landing domains, it renders the LandingPage;
 * otherwise, it redirects into the school website shell home route.
 */
function RootRoute() {
  const hostname = window.location.hostname.toLowerCase();
  const tenantContext = useMemo(() => resolveTenantContext(), []);

  // Define all domains that should display the LandingPage
  const landingPageDomains = ['www.skhool.in', 'skhool.in', 'localhost'];

  // Memoize the check to avoid unnecessary recalculations on re-renders
  const isLandingDomain = useMemo(
    () => landingPageDomains.includes(hostname),
    [hostname]
  );

  const shouldOpenLocalPreviewHome = useMemo(
    () => hostname === 'localhost' && tenantContext.source === 'local-preview',
    [hostname, tenantContext.source]
  );

  if (shouldOpenLocalPreviewHome) {
    const search = window.location.search || '';
    return <Navigate to={`/preview-home${search}`} replace />;
  }

  return isLandingDomain ? <LandingPage /> : <Navigate to="/preview-home" replace />;
}

export default RootRoute;
